import type { CourseHole } from '../../lib/golfRound'

/** Accessible name for a hole control, including its ready-media indicator. */
export function holeControlLabel(
  number: number,
  card: CourseHole | undefined,
  mediaCount: number,
): string {
  const parts = [card ? `Hole ${number}, par ${card.par}` : `Hole ${number}`]
  if (mediaCount > 0) {
    parts.push(`${mediaCount} media ${mediaCount === 1 ? 'item' : 'items'}`)
  }
  return parts.join(', ')
}
